import React, { useEffect, useState } from 'react'
import ModalForm from '../components/common/modal-form'
import MethodItem from '../components/order/receive-method/MethodItem'

import { useTranslation } from 'react-i18next'
import {
    APP_SERVICE,
    ORDER_METHOD,
    PARAMS_NAME,
    TABLET_ORDER_METHOD,
} from '../constants'
import { useDispatch, useSelector } from 'react-redux'
import { getTabletOrderMethod } from '../selectors'
import { useLocation } from 'react-router'
import { setTabletOrderMethod } from '../actions/orderActions'
import qs from 'query-string'
import paths from '../routes/paths'

import IconTakeAGo from '../assets/icons/mang_di.svg'
import IconRestaurant from '../assets/images/pickup.png'

const ModalTabletQRCodeType = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const location = useLocation()

    const [isOpen, setIsOpen] = useState(false)

    const tabletOrderMethod = useSelector(getTabletOrderMethod)
    const orderMethod = useSelector(state => state.OrderReducer.orderMethod)
    const skipMethod = useSelector(state => state.RestaurantReducer.settings?.tablet_random?.skip_method)

    const handleChooseMethod = method => {
        dispatch(setTabletOrderMethod(method))
    }

    const validContext = () => {
        const params = qs.parse(location.search)

        return (
            APP_SERVICE === ORDER_METHOD.TABLE_QRCODE &&
            !params[PARAMS_NAME.ORDER_GO_ID] &&
            !params[PARAMS_NAME.ORDER_WEB_ID] &&
            !location.pathname.includes(paths.notFound) &&
            !location.pathname.includes(paths.unSupport)
        )
    }

    useEffect(() => {
        if (!orderMethod) {
            return
        }

        if (tabletOrderMethod) {
            return setIsOpen(false)
        }

        if (!tabletOrderMethod && skipMethod) {
            setIsOpen(false)
            return handleChooseMethod(TABLET_ORDER_METHOD.TAKE_A_GO)
        }

        validContext() && setIsOpen(true)
    }, [tabletOrderMethod, orderMethod])

    return (
        <ModalForm isOpen={isOpen} rootClass="modal-method" centered>
            <div className="method-title text-center">
                <b>{t('modalTableOrderMethod.title')}</b>
            </div>

            <div className="wrap-menu-list">
                <div className="method-list">
                    <MethodItem
                        onClick={() =>
                            handleChooseMethod(TABLET_ORDER_METHOD.AT_RES)
                        }
                        title={t('modalTableOrderMethod.lbAtRestaurant')}
                        image={IconRestaurant}
                    />
                    <MethodItem
                        onClick={() =>
                            handleChooseMethod(TABLET_ORDER_METHOD.TAKE_A_GO)
                        }
                        title={t('modalTableOrderMethod.lbTakeAGo')}
                        image={IconTakeAGo}
                    />
                </div>
            </div>
        </ModalForm>
    )
}

export default ModalTabletQRCodeType
